<template>
  <div>
    <h1 v-if="element.tag == 'h1'" @click="edit = !edit">
      <template v-if="!edit">{{ element.innerHtml }}</template>
      <ContentEditable v-model="element.innerHtml" />
    </h1>
    <div
      class="paragraph"
      v-if="element.tag == 'p'"
      v-html="element.innerHtml"
    ></div>
  </div>
</template>

<script>
/* eslint-disable*/
export default {
  name: "ContentElements",
  props: {
    value: {
      default: null,
    },
    item: {
      type: Object,
    },
  },
  components: {
    ContentEditable: () => import("./ContentEditable.vue"),
  },
  data() {
    return {
      edit: false,
      element: {},
      date: {
        menu: false,
        model: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
      },
    };
  },
  mounted() {
    this.element = this.value;
  },
};
</script>

<style></style>
